import { component } from 'picoapp'
import SearchModal from '@/utils/search-modal.js'
// import { enableBodyScroll, disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

class Header {

  constructor(node, ctx) {
    // bindings
    this.gotSendy = this.gotSendy.bind(this)
    this.onPJAXSuccess = this.onPJAXSuccess.bind(this)
    this.openMenu = this.openMenu.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.onMenuBtnClick = this.onMenuBtnClick.bind(this)
    this.onClickCloseMenu = this.onClickCloseMenu.bind(this)
    this.onCartUpdated = this.onCartUpdated.bind(this)
    this.onCartClick = this.onCartClick.bind(this)
    this.onBgCartClick = this.onBgCartClick.bind(this)
    this.setCartOpenState = this.setCartOpenState.bind(this)
    this.onClickSearchBtn = this.onClickSearchBtn.bind(this)

    // selectors
    this._node = node;
    this._menu_btn = document.getElementById('menu-btn')
    this._side_nav_content = document.getElementById('side-nav-content')
    this._side_nav_bg = document.getElementById('side-nav-bg')
    this._side_nav_close_btn = document.getElementById('side-nav-close-btn')
    this._cart_btn = document.getElementById('cart-btn')
    this._cart_count = document.getElementById('cart-count')
    this._cart_items = document.getElementById('custom-cart-count')
    this._custom_cart_bg = document.getElementById('custom-cart-bg')
    this._nav_links = document.getElementsByClassName('nav-link')
    this._search_btn = document.getElementById('search-btn')
    this._search_modal = false

    // privates
    this._ctx = ctx

    // event listeners
    document.addEventListener('pjax:send', this.gotSendy)
    document.addEventListener('pjax:success', this.onPJAXSuccess)
    this._menu_btn.addEventListener('click', this.onMenuBtnClick, false)
    this._side_nav_bg.addEventListener('click', this.onClickCloseMenu, false)
    this._side_nav_close_btn.addEventListener('click', this.onClickCloseMenu, false)
    this._cart_btn.addEventListener('click', this.onCartClick, false)
    this._custom_cart_bg.addEventListener('click', this.onBgCartClick, false)
    this._search_btn.addEventListener('click', this.onClickSearchBtn, false)
    this._ctx.on('cart:updated', this.onCartUpdated)

    // init
    if (this._ctx.getState().pjax === false) {
      this.init()
    }

    this.unmount.bind(this)
  }

  //
  // Init.
  //
  init() {
    this.setActiveStuff()
  }

  //
  // You know you want to send it.
  //
  gotSendy() {
    this.closeMenu()
    this.setCartOpenState(false)
  }

  //
  // Handle PJAX success.
  //
  onPJAXSuccess() {
    this.setActiveStuff()
  }

  //
  // Set active stuff.
  //
  setActiveStuff() {
    let path = window.location.pathname

    if (path === '/products') {
      path = '/collections/all'
    }

    Array.from(this._nav_links).forEach((link) => {
      let href = link.getAttribute('href')
      link.classList.remove('active')

      if (path === href) {
        link.classList.add('active')
      }
    })
  }

  //
  // Handle menu btn click.
  //
  onMenuBtnClick() {
    if (document.body.classList.contains('open-menu') === false) {
      this.openMenu()
    }
  }

  onClickSearchBtn() {
    this._search_modal = new SearchModal()
    this._search_modal.activateSearchModal()
  }

  //
  // Handle menu bg click.
  //
  onClickCloseMenu() {
    if (document.body.classList.contains('open-menu') === true) {
      this.closeMenu()
    }
  }

  onBgCartClick() {
    if (document.body.classList.contains('cart-open') === true) {
      this.setCartOpenState(false)
    }
  }

  //
  // Open menu.
  //
  openMenu(menu) {
    if (this._ctx.getState().cartOpen === true) {
      this.setCartOpenState(false)
    }

    this._side_nav_bg.offsetHeight
    this._side_nav_content.scrollTop = 0
    document.body.classList.add('open-menu')
    document.body.classList.add('lock')
    // disableBodyScroll(this._side_nav_content)
  }

  //
  // Close menu.
  //
  closeMenu() {
    document.body.classList.remove('cart-open')
    document.body.classList.remove('open-menu')
    document.body.classList.remove('lock')
    // clearAllBodyScrollLocks()
  }

  //
  // Handle cart updated.
  //
  onCartUpdated(state) {
    let cnt = state.cart.item_count,
        label = cnt === 0 || cnt > 1 ? 'items' : 'item'

    this._cart_btn.classList.remove('empty')
    if (cnt <= 0) {
      this._cart_btn.classList.add('empty')
    }

    this._cart_count.innerText = cnt
    this._cart_items.innerText = `${cnt} ${label}`
  }

  //
  // Cart click
  //
  onCartClick() {
    if (this._ctx.getState().cartOpen === false) {
      this.setCartOpenState(true)
    } else {
      this.setCartOpenState(false)
    }
  }

  //
  // Set global cart open state.
  //
  setCartOpenState(open) {
    this._ctx.emit('cart:toggle', (state) => {
      return {
        cartOpen: open
      }
    })
  }

  //
  // Unmount.
  //
  unmount() {
    document.removeEventListener('pjax:send', this.gotSendy)
    document.removeEventListener('pjax:success', this.onPJAXSuccess)
    this._menu_btn.removeEventListener('click', this.onMenuBtnClick, false)
    this._side_nav_bg.removeEventListener('click', this.onClickCloseMenu, false)
    this._side_nav_close_btn.removeEventListener('click', this.onClickCloseMenu, false)
    this._cart_btn.removeEventListener('click', this.onCartClick, false)
    this._custom_cart_bg.removeEventListener('click', this.onBgCartClick, false)
    this._search_btn.removeEventListener('click', this.onClickSearchBtn, false)
  }
}

export default component((node, ctx) => new Header(node, ctx))
